<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 md2>
        <h3>Attributes
          <v-dialog v-model="dialog" max-width="500px" @keydown.esc="close" persistent>
            <template v-slot:activator="{ on }">
              <v-icon
              style="margin-bottom:-2px;"
              :disabled="!getWikiEntity.EntityTypeRelations.length" @click="newItem">add</v-icon>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                      <v-select
                        :items="allowedAttributeTypes"
                        item-value="attribute_type_id"
                        item-text="attribute_type_label"
                        v-model.number="editedItem.attribute_type_id"
                        label="Attribute Type"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 md12 v-show="selectedAttributeType && selectedAttributeType.attribute_type_value_type === 'text'">
                      <v-text-field
                      v-model="editedItem.attribute_value_text"
                      label="Value ( text )" />
                    </v-flex>
                    <v-flex xs12 sm12 md12 v-show="selectedAttributeType && selectedAttributeType.attribute_type_value_type === 'number'">
                      <v-text-field
                      v-model.number="editedItem.attribute_value_number"
                      type="number"
                      label="Value ( number )" />
                    </v-flex>
                    <v-flex xs12 sm12 md12 v-show="selectedAttributeType">
                      <v-textarea
                        outline
                        :counter="1000"
                        v-model="editedItem.attribute_note"
                        label="Attribute note" />
                    </v-flex>
                    <v-flex xs12 sm12 md12 v-show="selectedAttributeType">
                      <br />
                      <br />
                      <v-textarea
                        color="orange orange-darken-4"
                        outline
                        :counter="1000"
                        v-model="comment"
                        label="Source of knowledge"
                        required />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <ApolloMutation
                  :mutation="require('@/graphql/Wiki/CreateWikiChangeRequest.gql')"
                  :variables="dialog && {
                    WikiChangeRequestInput: {
                      target_type: 'wiki_attribute',
                      target_id: this.editedItem.attribute_id,
                      request_type: this.editedIndex === -1 ? 'create' : 'update',
                      comment: this.comment || '',
                      ChangeRequestFields: [{
                        target_field: 'entity_id',
                        new_value_fk: this.getWikiEntity.entity_id
                      }, {
                        target_field: 'attribute_type_id',
                        new_value_fk: this.editedItem.attribute_type_id
                      }, {
                        target_field: 'attribute_value_text',
                        new_value_text: this.editedItem.attribute_value_text
                      }, {
                        target_field: 'attribute_value_number',
                        new_value_number: this.editedItem.attribute_value_number
                      }, {
                        target_field: 'attribute_note',
                        new_value_text: this.editedItem.attribute_note
                      }]
                    }
                  } || {}"
                  @done="close()"
                  @error="addError($event.message)"
                >
                  <template slot-scope="{ mutate, loading }">
                    <v-btn flat @click="close">Cancel</v-btn>
                    <v-btn color="primary" @click="mutate()" :disabled="loading || disableSaveBtn">Save</v-btn>
                  </template>
                </ApolloMutation>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </h3>
      </v-flex>
      <v-flex xs12 md10 style="padding-top:3px;">
        <v-layout row wrap v-for="attributeType in entityAttributeTypes" :key="attributeType.attribute_type_id">
          <v-flex xs12 md2>
            <span v-text="attributeType.attribute_type_label"/>:
          </v-flex>
          <v-flex xs12 md10>
            <div v-for="attribute in getWikiEntity.Attributes.filter(attr => attr.attribute_type_id == attributeType.attribute_type_id)" :key="attribute.attribute_id">
              <!-- #TODO v2: put v-chip back. in <v2, v-tooltip doesn't work inside a v-chip which is inside a v-dialog -->
              <span v-text="attribute.attribute_value_text"/>
              <span v-text="attribute.attribute_value_number"/>&nbsp;
              <v-tooltip top v-show="attribute.attribute_note">
                <v-icon style="font-size: 18px;" slot="activator" >help_outline</v-icon>
                <span v-text="attribute.attribute_note" />
              </v-tooltip>

              <v-icon
                style="font-size: 18px;"
                @click="editItem(attribute)">
                edit
              </v-icon>
              <v-dialog v-model="dialogDelete[attribute.attribute_id]" max-width="350px" persistent>
                <template v-slot:activator="{ on }">
                  <v-icon style="font-size: 18px;" v-on="on" >clear</v-icon>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">Remove attribute</span>
                  </v-card-title>
                  <v-card-text>
                    <v-textarea
                      class="ma-2"
                      color="orange orange-darken-4"
                      outline
                      :counter="1000"
                      v-model="comment"
                      label="Source of knowledge"
                      required />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="closeDeleteMenu(attribute.attribute_id)">Cancel</v-btn>
                    <v-btn color="error darken-1" @click="deleteAttribute(parseInt(attribute.attribute_id))">Delete</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import { mapMutations, mapState } from 'vuex'
import ALL_WIKI_ENTITY_TYPE_DETAILS from '@/graphql/Wiki/AllEntityTypeDetails.gql'
import CREATE_WIKI_CHANGE_REQUEST from '@/graphql/Wiki/CreateWikiChangeRequest.gql'
import GET_WIKI_ENTITY from '@/graphql/Wiki/GetWikiEntity.gql'
export default {
  name: 'AttributesSection',
  data () {
    return {
      getWikiEntity: {},
      allWikiEntityTypes: [],
      dialog: false,
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      comment: '',
      menu: false,
      dialogDelete: {}
    }
  },
  computed: {
    ...mapState('wiki', ['entityId']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Attribute' : 'Edit Attribute'
    },
    allowedAttributeTypes () {
      if (!this.allWikiEntityTypes) { return [] }
      let entityTypeIds = this.getWikiEntity.EntityTypes.map(entityEntityType => entityEntityType.entity_type_id)
      let entityTypes = this.allWikiEntityTypes.filter(entityType => entityTypeIds.indexOf(entityType.entity_type_id) > -1)
      return entityTypes.map(type => type.AttributeTypes).flat()
    },
    selectedAttributeType () {
      return this.allowedAttributeTypes.find(entityType => entityType.attribute_type_id === this.editedItem.attribute_type_id)
    },
    allAttributes () {
      return (this.allWikiEntityTypes) ? this.allWikiEntityTypes.map(type => type.AttributeTypes).flat() : []
    },
    entityAttributeTypes () {
      return (this.allAttributes.length && this.getWikiEntity.Attributes)
        ? [...new Set(this.getWikiEntity.Attributes.map(a => a.attribute_type_id))].map(key => this.allAttributes.find(a => a.attribute_type_id === key))
        : []
    },
    disableSaveBtn () {
      let res = this.selectedAttributeType === undefined ||
        (this.selectedAttributeType && this.selectedAttributeType.attribute_type_value_type === 'text' &&
          (this.editedItem.attribute_value_text === undefined || this.editedItem.attribute_value_text === '')) ||
        (this.selectedAttributeType && this.selectedAttributeType.attribute_type_value_type === 'number' &&
          (this.editedItem.attribute_value_number === undefined || !this.editedItem.attribute_value_number))
      return res
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  methods: {
    ...mapMutations(['addError']),
    newItem () {
      this.editedItem = Object.assign({}, this.defaultItem)
      this.comment = ''
      this.dialog = true
    },
    editItem (item) {
      this.editedIndex = this.getWikiEntity.Attributes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.comment = ''
      this.dialog = true
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    deleteAttribute (attributeId) {
      this.$apollo.mutate({
        mutation: CREATE_WIKI_CHANGE_REQUEST,
        variables: {
          WikiChangeRequestInput: {
            target_type: 'wiki_attribute',
            target_id: attributeId,
            request_type: 'delete',
            comment: this.comment || '',
            ChangeRequestFields: [{
              target_field: 'entity_id',
              new_value_fk: this.getWikiEntity.entity_id
            }]
          }
        }
      }).then((data) => {
        this.comment = ''
        this.dialogDelete[attributeId] = false
      })
        .catch((error) => {
          if (error.networkError.statusCode === 401) {
            this.$auth0.login()
          } else {
            this.addError(error)
          }
        })
    },
    closeDeleteMenu (attributeId) {
      this.dialogDelete[attributeId] = false
      this.menu = ''
    }
  },
  apollo: {
    allWikiEntityTypes: {
      query: ALL_WIKI_ENTITY_TYPE_DETAILS
    },
    getWikiEntity: {
      query: GET_WIKI_ENTITY,
      variables () {
        return {
          entity_id: parseInt(this.entityId)
        }
      },
      skip () {
        return !this.entityId
      }
    }
  }
}
</script>

